module.exports = __webpack_public_path__ + "img/person.b095b152.png";